// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.device-monitor {
  padding: 24px;
  min-height: 100vh;
  background: var(--m-background-color);
}
.device-monitor .loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  color: var(--m-text-light);
}
.device-monitor .loading-spinner .spin {
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
  color: var(--m-primary);
}
.device-monitor .loading-spinner p {
  color: var(--m-text-muted);
  font-size: 14px;
}
.device-monitor .monitor-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
  padding: 20px;
  background: var(--m-card-background-color);
  border-radius: var(--m-border-radius-md, 12px);
  border: 1px solid var(--m-border-card-file);
  box-shadow: var(--m-box-shadow-car, 0 2px 8px rgba(0, 0, 0, 0.04));
  position: relative;
}
.device-monitor .monitor-header .header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}
.device-monitor .monitor-header .header-left h1 {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--m-text);
}
.device-monitor .monitor-header .header-left h1 svg {
  color: var(--m-primary);
}
.device-monitor .monitor-header .header-left .connection-status {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  background: var(--m-background-subtle-primary);
  border-radius: 20px;
  border: 1px solid var(--m-primary-subtle);
  font-size: 13px;
  font-weight: 500;
  color: var(--m-primary);
}
.device-monitor .monitor-header .header-left .connection-status .status-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
.device-monitor .monitor-header .header-left .connection-status .status-indicator.online {
  background: var(--m-success);
  box-shadow: 0 0 8px var(--m-success);
  animation: pulse 2s infinite;
}
.device-monitor .monitor-header .header-left .connection-status .status-indicator.offline {
  background: var(--m-subtle-xbolder);
}
.device-monitor .monitor-header .header-right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  position: relative;
}
.device-monitor .monitor-header .header-right .period-selector {
  display: flex;
  align-items: center;
  gap: 4px;
  background: var(--m-background-subtle-primary);
  border: 1px solid var(--m-primary-subtle);
  border-radius: 8px;
  padding: 4px;
}
.device-monitor .monitor-header .header-right .period-selector .day-navigation {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-right: 4px;
  padding-right: 8px;
  border-right: 1px solid var(--m-primary-subtle);
}
.device-monitor .monitor-header .header-right .period-selector .day-navigation .nav-day-btn {
  padding: 6px 10px;
  background: transparent;
  color: var(--m-text-light);
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
}
.device-monitor .monitor-header .header-right .period-selector .day-navigation .nav-day-btn:hover:not(:disabled) {
  background: var(--m-background-subtle-primary-hovered);
  color: var(--m-text);
}
.device-monitor .monitor-header .header-right .period-selector .day-navigation .nav-day-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.device-monitor .monitor-header .header-right .period-selector .day-navigation .selected-date-label {
  padding: 6px 12px;
  color: var(--m-text);
  font-size: 13px;
  font-weight: 500;
  min-width: 80px;
  text-align: center;
  white-space: nowrap;
}
.device-monitor .monitor-header .header-right .period-selector .period-btn {
  padding: 8px 16px;
  background: transparent;
  color: var(--m-text-light);
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s ease;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 6px;
}
.device-monitor .monitor-header .header-right .period-selector .period-btn:hover {
  background: var(--m-background-subtle-primary-hovered);
  color: var(--m-text);
}
.device-monitor .monitor-header .header-right .period-selector .period-btn.active {
  background: var(--m-primary);
  color: var(--m-white);
  box-shadow: 0 2px 4px rgba(12, 132, 121, 0.2);
}
.device-monitor .monitor-header .header-right .custom-date-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  background: var(--m-background-subtle-primary);
  color: var(--m-text);
  border: 1px solid var(--m-border-card-file);
  border-radius: 6px;
  font-size: 12px;
  font-weight: 400;
  white-space: nowrap;
}
.device-monitor .monitor-header .header-right .custom-date-badge span {
  display: flex;
  align-items: center;
}
.device-monitor .monitor-header .header-right .custom-date-badge .clear-badge-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  width: 16px;
  height: 16px;
  cursor: pointer;
  padding: 0;
  color: var(--m-text-light);
  flex-shrink: 0;
}
.device-monitor .monitor-header .header-right .custom-date-badge .clear-badge-btn:hover {
  color: var(--m-text);
}
.device-monitor .monitor-header .header-right .custom-date-badge .clear-badge-btn svg {
  width: 12px;
  height: 12px;
}
.device-monitor .monitor-header .header-right .custom-date-range-picker {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: var(--m-card-background-color);
  border: 1px solid var(--m-border-card-file);
  border-radius: var(--m-border-radius-md, 12px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  padding: 20px;
  z-index: 1000;
  min-width: 450px;
  max-width: 550px;
  margin-top: 8px;
}
.device-monitor .monitor-header .header-right .custom-date-range-picker .date-range-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--m-border-card-file);
}
.device-monitor .monitor-header .header-right .custom-date-range-picker .date-range-header span {
  font-size: 14px;
  font-weight: 600;
  color: var(--m-text);
}
.device-monitor .monitor-header .header-right .custom-date-range-picker .date-range-header .close-date-picker {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  background: transparent;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  color: var(--m-text-light);
  transition: all 0.2s ease;
}
.device-monitor .monitor-header .header-right .custom-date-range-picker .date-range-header .close-date-picker:hover {
  background: var(--m-background-subtle-primary);
  color: var(--m-text);
}
.device-monitor .monitor-header .header-right .custom-date-range-picker .date-range-inputs {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.device-monitor .monitor-header .header-right .custom-date-range-picker .date-range-inputs .date-input-group {
  flex: 1 1;
}
.device-monitor .monitor-header .header-right .custom-date-range-picker .date-range-inputs .date-range-actions {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}
.device-monitor .monitor-header .header-right .custom-date-range-picker .date-range-inputs .date-range-actions .apply-date-range-btn {
  flex: 1 1;
  padding: 10px 20px;
  background: var(--m-background-primary);
  color: var(--m-white);
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
}
.device-monitor .monitor-header .header-right .custom-date-range-picker .date-range-inputs .date-range-actions .apply-date-range-btn:hover:not(:disabled) {
  background: var(--m-background-primary-hovered);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(12, 132, 121, 0.3);
}
.device-monitor .monitor-header .header-right .custom-date-range-picker .date-range-inputs .date-range-actions .apply-date-range-btn:active:not(:disabled) {
  transform: translateY(0);
}
.device-monitor .monitor-header .header-right .custom-date-range-picker .date-range-inputs .date-range-actions .apply-date-range-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: var(--m-subtle-xbolder);
}
.device-monitor .monitor-header .header-right .custom-date-range-picker .date-range-inputs .date-range-actions .clear-date-range-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 16px;
  background: var(--m-background-subtle-danger);
  color: var(--m-danger);
  border: 1px solid var(--m-border-danger);
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s ease;
}
.device-monitor .monitor-header .header-right .custom-date-range-picker .date-range-inputs .date-range-actions .clear-date-range-btn:hover {
  background: var(--m-danger);
  color: var(--m-white);
}
.device-monitor .monitor-header .refresh-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: var(--m-background-primary);
  color: var(--m-white);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
}
.device-monitor .monitor-header .refresh-btn:hover {
  background: var(--m-background-primary-hovered);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(12, 132, 121, 0.2);
}
.device-monitor .monitor-header .refresh-btn:active {
  transform: translateY(0);
}
.device-monitor .machine-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}
.device-monitor .machine-stats .stat-card {
  background: var(--m-card-background-color);
  padding: 20px;
  border-radius: var(--m-border-radius-md, 12px);
  border: 1px solid var(--m-border-card-file);
  box-shadow: var(--m-box-shadow-car, 0 2px 8px rgba(0, 0, 0, 0.04));
  text-align: center;
  transition: all 0.2s ease;
}
.device-monitor .machine-stats .stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}
.device-monitor .machine-stats .stat-card .stat-label {
  font-size: 13px;
  font-weight: 500;
  color: var(--m-text-light);
  margin-bottom: 10px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.device-monitor .machine-stats .stat-card .stat-value {
  font-size: 2rem;
  font-weight: 700;
  color: var(--m-text);
}
.device-monitor .machine-stats .stat-card .stat-value.online {
  color: var(--m-success);
}
.device-monitor .machine-stats .stat-card .stat-value.offline {
  color: var(--m-danger);
}
.device-monitor .machines-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
  gap: 20px;
}
.device-monitor .machines-grid .machine-card {
  background: var(--m-card-background-color);
  border-radius: var(--m-border-radius-md, 12px);
  border: 1px solid var(--m-border-card-file);
  box-shadow: var(--m-box-shadow-car, 0 2px 8px rgba(0, 0, 0, 0.04));
  overflow: visible;
  transition: all 0.2s ease;
  position: relative;
}
.device-monitor .machines-grid .machine-card.machine-card--dropdown-open {
  z-index: 10100;
}
.device-monitor .machines-grid .machine-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: var(--m-subtle-xbolder);
}
.device-monitor .machines-grid .machine-card.online::before {
  background: var(--m-success);
}
.device-monitor .machines-grid .machine-card.offline {
  opacity: 0.85;
}
.device-monitor .machines-grid .machine-card.offline::before {
  background: var(--m-danger);
}
.device-monitor .machines-grid .machine-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}
.device-monitor .machines-grid .machine-card .card-header {
  padding: 20px;
  background: var(--m-background-subtle-primary);
  border-bottom: 1px solid var(--m-border-card-file);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.device-monitor .machines-grid .machine-card .card-header .machine-name {
  display: flex;
  align-items: center;
  gap: 12px;
}
.device-monitor .machines-grid .machine-card .card-header .machine-name svg {
  color: var(--m-primary);
  flex-shrink: 0;
}
.device-monitor .machines-grid .machine-card .card-header .machine-name h3 {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 600;
  color: var(--m-text);
}
.device-monitor .machines-grid .machine-card .card-header .header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}
.device-monitor .machines-grid .machine-card .card-header .header-actions .telemetry-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  background: var(--m-background-subtle-primary);
  color: var(--m-primary);
  border: 1px solid var(--m-primary-subtle);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.device-monitor .machines-grid .machine-card .card-header .header-actions .telemetry-btn:hover {
  background: var(--m-primary);
  color: var(--m-white);
  transform: scale(1.05);
}
.device-monitor .machines-grid .machine-card .card-header .header-actions .telemetry-btn:active {
  transform: scale(0.95);
}
.device-monitor .machines-grid .machine-card .card-header .header-actions .view-activity-mini-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background: var(--m-primary);
  color: var(--m-white);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-right: 8px;
}
.device-monitor .machines-grid .machine-card .card-header .header-actions .view-activity-mini-btn:hover {
  background: var(--m-background-primary-hovered);
  transform: scale(1.05);
}
.device-monitor .machines-grid .machine-card .card-header .header-actions .view-activity-mini-btn:active {
  transform: scale(0.95);
}
.device-monitor .machines-grid .machine-card .card-header .header-actions .view-activity-mini-btn svg {
  flex-shrink: 0;
}
.device-monitor .machines-grid .machine-card .card-header .header-actions .status-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.device-monitor .machines-grid .machine-card .card-header .header-actions .status-badge.online {
  background: var(--m-background-subtle-success);
  color: var(--m-success);
  border: 1px solid var(--m-border-success);
}
.device-monitor .machines-grid .machine-card .card-header .header-actions .status-badge.offline {
  background: var(--m-background-subtle-danger);
  color: var(--m-danger);
  border: 1px solid var(--m-border-danger);
}
.device-monitor .machines-grid .machine-card .card-body {
  padding: 15px;
}
.device-monitor .machines-grid .machine-card .card-body .info-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-size: 14px;
}
.device-monitor .machines-grid .machine-card .card-body .info-row svg {
  color: var(--m-primary);
  flex-shrink: 0;
}
.device-monitor .machines-grid .machine-card .card-body .info-row .label {
  font-weight: 600;
  color: var(--m-text);
}
.device-monitor .machines-grid .machine-card .card-body .info-row .value {
  color: var(--m-text-light);
}
.device-monitor .machines-grid .machine-card .card-body .divider {
  height: 1px;
  background: var(--m-border-card-file);
  margin: 10px 0;
}
.device-monitor .machines-grid .machine-card .card-body .live-data {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 12px;
}
.device-monitor .machines-grid .machine-card .card-body .live-data .data-item {
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  padding: 8px;
  background: var(--m-background-subtle-primary);
  border: 1px solid var(--m-primary-subtle);
  border-radius: 10px;
  transition: all 0.2s ease;
}
.device-monitor .machines-grid .machine-card .card-body .live-data .data-item:hover {
  background: var(--m-background-subtle-primary-hovered);
  border-color: var(--m-primary-subtle-hovered);
}
.device-monitor .machines-grid .machine-card .card-body .live-data .data-item .data-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 33px;
  height: 33px;
  background: var(--m-primary);
  color: var(--m-white);
  border-radius: 10px;
  font-size: 18px;
  flex-shrink: 0;
}
.device-monitor .machines-grid .machine-card .card-body .live-data .data-item .data-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 7px;
}
.device-monitor .machines-grid .machine-card .card-body .live-data .data-item .data-content .data-label {
  font-size: 12px;
  font-weight: 500;
  color: var(--m-text-light);
  text-transform: uppercase;
  letter-spacing: 0.3px;
  text-align: center;
}
.device-monitor .machines-grid .machine-card .card-body .live-data .data-item .data-content .data-value {
  font-size: 2rem;
  font-weight: 600;
  color: var(--m-text);
  text-align: center;
}
.device-monitor .machines-grid .machine-card .card-body .last-seen {
  margin-top: 16px;
  padding: 10px 14px;
  background: var(--m-background-subtle-warning);
  border: 1px solid var(--m-border-warning);
  border-radius: 8px;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  color: var(--m-text-warning);
}
.device-monitor .machines-grid .machine-card .card-footer {
  padding: 14px 20px;
  background: var(--m-subtle-card-background-color);
  border-top: 1px solid var(--m-border-card-file);
}
.device-monitor .machines-grid .machine-card .card-footer small {
  color: var(--m-text-muted);
  font-size: 13px;
  line-height: 1.5;
}
.device-monitor .machines-grid .no-machines {
  grid-column: 1/-1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  background: var(--m-card-background-color);
  border: 1px solid var(--m-border-card-file);
  border-radius: var(--m-border-radius-md, 12px);
}
.device-monitor .machines-grid .no-machines svg {
  color: var(--m-subtle-xbolder);
  opacity: 0.5;
}
.device-monitor .machines-grid .no-machines h3 {
  margin: 1.5rem 0 0.5rem;
  color: var(--m-text);
  font-weight: 600;
  font-size: 1.25rem;
}
.device-monitor .machines-grid .no-machines p {
  margin: 0;
  color: var(--m-text-light);
  font-size: 14px;
}

.device-monitor-inventory-edit {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 4px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
}
.device-monitor-inventory-edit__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
}

.device-monitor-inventory-dropdown {
  position: relative;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  z-index: 10050;
}
.device-monitor-inventory-dropdown__trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  min-height: 42px;
  padding: 10px 12px;
  background: var(--m-card-background-color);
  border: 1px solid var(--m-border-card-file);
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  color: var(--m-text);
  cursor: pointer;
  text-align: left;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}
.device-monitor-inventory-dropdown__trigger:hover {
  border-color: var(--m-primary-subtle-hovered);
  background: var(--m-background-subtle-primary-hovered, var(--m-card-background-color));
}
.device-monitor-inventory-dropdown__trigger:focus-visible {
  outline: none;
  border-color: var(--m-primary);
  box-shadow: 0 0 0 3px var(--m-background-subtle-primary);
}
.device-monitor-inventory-dropdown__value {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.3;
}
.device-monitor-inventory-dropdown__chevron {
  flex-shrink: 0;
  color: var(--m-text-light);
  transition: transform 0.2s ease;
}
.device-monitor-inventory-dropdown__chevron.is-open {
  transform: rotate(180deg);
  color: var(--m-primary);
}
.device-monitor-inventory-dropdown__menu {
  position: absolute;
  left: 0;
  right: 0;
  top: calc(100% + 6px);
  z-index: 10051;
  display: flex;
  flex-direction: column;
  max-height: min(220px, 44vh);
  overflow: hidden;
  padding: 0;
  background: var(--m-card-background-color);
  border: 1px solid var(--m-border-card-file);
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.06), 0 12px 28px rgba(0, 0, 0, 0.12);
}
.device-monitor-inventory-dropdown__search {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  padding: 8px 10px;
  border-bottom: 1px solid var(--m-border-card-file);
  background: var(--m-background-subtle-primary, transparent);
}
.device-monitor-inventory-dropdown__search-icon {
  flex-shrink: 0;
  color: var(--m-text-light);
}
.device-monitor-inventory-dropdown__search-input {
  flex: 1 1;
  min-width: 0;
  border: none;
  background: transparent;
  font-size: 13px;
  font-weight: 500;
  color: var(--m-text);
  outline: none;
}
.device-monitor-inventory-dropdown__search-input::placeholder {
  color: var(--m-text-light);
  font-weight: 400;
}
.device-monitor-inventory-dropdown__menu-scroll {
  flex: 1 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 6px;
  -webkit-overflow-scrolling: touch;
}
.device-monitor-inventory-dropdown__menu-scroll::-webkit-scrollbar {
  width: 6px;
}
.device-monitor-inventory-dropdown__menu-scroll::-webkit-scrollbar-thumb {
  background: var(--m-primary-subtle);
  border-radius: 6px;
}
.device-monitor-inventory-dropdown__empty {
  padding: 14px 12px;
  text-align: center;
  font-size: 13px;
  font-weight: 500;
  color: var(--m-text-light);
  line-height: 1.4;
}
.device-monitor-inventory-dropdown__option {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 3px;
  width: 100%;
  padding: 10px 12px;
  margin-bottom: 2px;
  border: none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font: inherit;
  color: var(--m-text);
  transition: background 0.12s ease;
}
.device-monitor-inventory-dropdown__option:last-child {
  margin-bottom: 0;
}
.device-monitor-inventory-dropdown__option:hover {
  background: var(--m-background-subtle-primary);
}
.device-monitor-inventory-dropdown__option.is-selected {
  background: var(--m-background-subtle-primary);
  box-shadow: inset 0 0 0 1px var(--m-primary-subtle);
}
.device-monitor-inventory-dropdown__option--placeholder {
  font-size: 13px;
  font-weight: 500;
  color: var(--m-text-light);
  font-style: italic;
}
.device-monitor-inventory-dropdown__option--placeholder.is-selected {
  color: var(--m-text);
  font-style: normal;
}
.device-monitor-inventory-dropdown__option-code {
  width: 100%;
  font-size: 13px;
  font-weight: 700;
  color: var(--m-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.25;
}
.device-monitor-inventory-dropdown__option-name {
  width: 100%;
  font-size: 12px;
  font-weight: 500;
  color: var(--m-text-light);
  line-height: 1.35;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.device-monitor-product-type-modal__body {
  overflow: visible !important;
}

.device-monitor-product-type-modal {
  width: min(720px, 100vw - 24px) !important;
  max-width: min(720px, 100vw - 24px) !important;
}
@media (max-width: 640px) {
  .device-monitor-product-type-modal {
    width: calc(100vw - 16px) !important;
    max-width: calc(100vw - 16px) !important;
    border-radius: 12px !important;
  }
}

.device-monitor-product-type-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
}
.device-monitor-product-type-list__summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  border: 1px solid var(--m-border-card-file);
  border-radius: 10px;
  background: var(--m-background-subtle-primary, transparent);
}
.device-monitor-product-type-list__summary-label {
  font-size: 12px;
  font-weight: 700;
  color: var(--m-text-light);
  text-transform: uppercase;
  letter-spacing: 0.02em;
  white-space: nowrap;
}
.device-monitor-product-type-list__summary-value {
  flex: 1 1;
  min-width: 0;
  font-size: 13px;
  font-weight: 600;
  color: var(--m-text);
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.device-monitor-product-type-list__search {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border: 1px solid var(--m-border-card-file);
  border-radius: 10px;
  background: var(--m-background-subtle-primary, transparent);
}
.device-monitor-product-type-list__search-icon {
  flex-shrink: 0;
  color: var(--m-text-light);
}
.device-monitor-product-type-list__search-input {
  flex: 1 1;
  min-width: 0;
  border: none;
  background: transparent;
  font-size: 13px;
  font-weight: 500;
  color: var(--m-text);
  outline: none;
}
.device-monitor-product-type-list__search-input::placeholder {
  color: var(--m-text-light);
  font-weight: 400;
}
.device-monitor-product-type-list__items {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 6px;
  border: 1px solid var(--m-border-card-file);
  border-radius: 10px;
  background: var(--m-card-background-color);
  max-height: min(320px, 55vh);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.device-monitor-product-type-list__empty {
  padding: 14px 12px;
  text-align: center;
  font-size: 13px;
  font-weight: 500;
  color: var(--m-text-light);
}
.device-monitor-product-type-list__item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 3px;
  width: 100%;
  padding: 10px 12px;
  border: none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font: inherit;
  color: var(--m-text);
  transition: background 0.12s ease;
  position: relative;
}
.device-monitor-product-type-list__item:hover:not(:disabled) {
  background: var(--m-background-subtle-primary);
}
.device-monitor-product-type-list__item:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.device-monitor-product-type-list__item.is-selected {
  background: var(--m-background-subtle-primary);
  box-shadow: inset 0 0 0 1px var(--m-primary-subtle);
}
.device-monitor-product-type-list__item.is-selected::before {
  content: "";
  position: absolute;
  left: 0;
  top: 8px;
  bottom: 8px;
  width: 3px;
  border-radius: 3px;
  background: var(--m-primary);
}
.device-monitor-product-type-list__item--placeholder {
  font-size: 13px;
  font-weight: 500;
  color: var(--m-text-light);
  font-style: italic;
}
.device-monitor-product-type-list__placeholder {
  width: 100%;
}
.device-monitor-product-type-list__code {
  width: 100%;
  font-size: 13px;
  font-weight: 700;
  color: var(--m-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.25;
}
.device-monitor-product-type-list__name {
  width: 100%;
  font-size: 12px;
  font-weight: 500;
  color: var(--m-text-light);
  line-height: 1.35;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.device-monitor-product-type-list__selected {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 8px 12px;
  padding: 10px 12px;
  border: 1px solid var(--m-border-card-file);
  border-radius: 10px;
  background: var(--m-background-subtle-primary, transparent);
}
.device-monitor-product-type-list__selected-label {
  width: 100%;
  font-size: 12px;
  font-weight: 700;
  color: var(--m-text-light);
  text-transform: uppercase;
  letter-spacing: 0.02em;
}
.device-monitor-product-type-list__selected-empty {
  font-size: 13px;
  font-weight: 500;
  color: var(--m-text-light);
  font-style: italic;
}
.device-monitor-product-type-list__selected-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
}
.device-monitor-product-type-list__selected-chip {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  max-width: min(240px, 100%);
  padding: 8px 10px;
  border-radius: 8px;
  background: var(--m-card-background-color);
  box-shadow: inset 0 0 0 1px var(--m-primary-subtle);
}
.device-monitor-product-type-list__selected-chip .device-monitor-product-type-list__code,
.device-monitor-product-type-list__selected-chip .device-monitor-product-type-list__name {
  width: auto;
}
.device-monitor-product-type-list__pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.device-monitor-product-type-list__page-info {
  font-size: 13px;
  font-weight: 600;
  color: var(--m-text);
  white-space: nowrap;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
@media (max-width: 768px) {
  .device-monitor {
    padding: 16px;
  }
  .device-monitor .monitor-header {
    flex-direction: column;
    gap: 16px;
    align-items: stretch;
    padding: 16px;
  }
  .device-monitor .monitor-header .header-left {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  .device-monitor .monitor-header .header-left h1 {
    font-size: 1.25rem;
  }
  .device-monitor .monitor-header .header-right {
    flex-direction: column;
    width: 100%;
    gap: 12px;
    position: relative;
  }
  .device-monitor .monitor-header .header-right .period-selector {
    width: 100%;
    justify-content: stretch;
    flex-wrap: wrap;
  }
  .device-monitor .monitor-header .header-right .period-selector .period-btn {
    flex: 1 1;
    min-width: 80px;
  }
  .device-monitor .monitor-header .header-right .custom-date-range-picker {
    position: relative;
    top: auto;
    right: auto;
    width: 100%;
    min-width: auto;
    max-width: none;
  }
  .device-monitor .monitor-header .header-right .refresh-btn {
    width: 100%;
    justify-content: center;
  }
  .device-monitor .machine-stats {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
  .device-monitor .machine-stats .stat-card {
    padding: 16px;
  }
  .device-monitor .machine-stats .stat-card .stat-value {
    font-size: 1.5rem;
  }
  .device-monitor .machines-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/pages/DeviceMonitor/DeviceMonitor.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,iBAAA;EACA,qCAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,0BAAA;AACJ;AACI;EACE,kCAAA;EACA,mBAAA;EACA,uBAAA;AACN;AAEI;EACE,0BAAA;EACA,eAAA;AAAN;AAIE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,0CAAA;EACA,8CAAA;EACA,2CAAA;EACA,kEAAA;EACA,kBAAA;AAFJ;AAII;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAFN;AAIM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;AAFR;AAIQ;EACE,uBAAA;AAFV;AAMM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,8CAAA;EACA,mBAAA;EACA,yCAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AAJR;AAMQ;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAJV;AAMU;EACE,4BAAA;EACA,oCAAA;EACA,4BAAA;AAJZ;AAOU;EACE,mCAAA;AALZ;AAWI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;AATN;AAWM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,8CAAA;EACA,yCAAA;EACA,kBAAA;EACA,YAAA;AATR;AAWQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,+CAAA;AATV;AAWU;EACE,iBAAA;EACA,uBAAA;EACA,0BAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;AATZ;AAWY;EACE,sDAAA;EACA,oBAAA;AATd;AAYY;EACE,YAAA;EACA,mBAAA;AAVd;AAcU;EACE,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AAZZ;AAgBQ;EACE,iBAAA;EACA,uBAAA;EACA,0BAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAdV;AAgBU;EACE,sDAAA;EACA,oBAAA;AAdZ;AAiBU;EACE,4BAAA;EACA,qBAAA;EACA,6CAAA;AAfZ;AAoBM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,8CAAA;EACA,oBAAA;EACA,2CAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAlBR;AAoBQ;EACE,aAAA;EACA,mBAAA;AAlBV;AAqBQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,0BAAA;EACA,cAAA;AAnBV;AAqBU;EACE,oBAAA;AAnBZ;AAsBU;EACE,WAAA;EACA,YAAA;AApBZ;AAyBM;EACE,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,0CAAA;EACA,2CAAA;EACA,8CAAA;EACA,0CAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAvBR;AAyBQ;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kDAAA;AAvBV;AAyBU;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;AAvBZ;AA0BU;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;EACA,yBAAA;AAxBZ;AA0BY;EACE,8CAAA;EACA,oBAAA;AAxBd;AA6BQ;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA3BV;AA6BU;EACE,SAAA;AA3BZ;AA8BU;EACE,aAAA;EACA,QAAA;EACA,eAAA;AA5BZ;AA8BY;EACE,SAAA;EACA,kBAAA;EACA,uCAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AA5Bd;AA8Bc;EACE,+CAAA;EACA,2BAAA;EACA,6CAAA;AA5BhB;AA+Bc;EACE,wBAAA;AA7BhB;AAgCc;EACE,YAAA;EACA,mBAAA;EACA,mCAAA;AA9BhB;AAkCY;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,6CAAA;EACA,sBAAA;EACA,wCAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAhCd;AAkCc;EACE,2BAAA;EACA,qBAAA;AAhChB;AAwCI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,uCAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAtCN;AAwCM;EACE,+CAAA;EACA,2BAAA;EACA,8CAAA;AAtCR;AAyCM;EACE,wBAAA;AAvCR;AA4CE;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;AA1CJ;AA4CI;EACE,0CAAA;EACA,aAAA;EACA,8CAAA;EACA,2CAAA;EACA,kEAAA;EACA,kBAAA;EACA,yBAAA;AA1CN;AA4CM;EACE,2BAAA;EACA,0CAAA;AA1CR;AA6CM;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;AA3CR;AA8CM;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;AA5CR;AA8CQ;EACE,uBAAA;AA5CV;AA+CQ;EACE,sBAAA;AA7CV;AAmDE;EACE,aAAA;EACA,4DAAA;EACA,SAAA;AAjDJ;AAmDI;EACE,0CAAA;EACA,8CAAA;EACA,2CAAA;EACA,kEAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;AAjDN;AAmDM;EACE,cAAA;AAjDR;AAoDM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,mCAAA;AAlDR;AAsDQ;EACE,4BAAA;AApDV;AAwDM;EACE,aAAA;AAtDR;AAwDQ;EACE,2BAAA;AAtDV;AA0DM;EACE,2BAAA;EACA,yCAAA;AAxDR;AA2DM;EACE,aAAA;EACA,8CAAA;EACA,kDAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAzDR;AA2DQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAzDV;AA2DU;EACE,uBAAA;EACA,cAAA;AAzDZ;AA4DU;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;AA1DZ;AA8DQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA5DV;AA8DU;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,8CAAA;EACA,uBAAA;EACA,yCAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AA5DZ;AA8DY;EACE,4BAAA;EACA,qBAAA;EACA,sBAAA;AA5Dd;AA+DY;EACE,sBAAA;AA7Dd;AAiEU;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,4BAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;AA/DZ;AAiEY;EACE,+CAAA;EACA,sBAAA;AA/Dd;AAkEY;EACE,sBAAA;AAhEd;AAmEY;EACE,cAAA;AAjEd;AAqEU;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AAnEZ;AAqEY;EACE,8CAAA;EACA,uBAAA;EACA,yCAAA;AAnEd;AAsEY;EACE,6CAAA;EACA,sBAAA;EACA,wCAAA;AApEd;AA0EM;EACE,aAAA;AAxER;AA0EQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;AAxEV;AA0EU;EACE,uBAAA;EACA,cAAA;AAxEZ;AA2EU;EACE,gBAAA;EACA,oBAAA;AAzEZ;AA4EU;EACE,0BAAA;AA1EZ;AA8EQ;EACE,WAAA;EACA,qCAAA;EACA,cAAA;AA5EV;AA+EQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AA7EV;AA+EU;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;EACA,8CAAA;EACA,yCAAA;EACA,mBAAA;EACA,yBAAA;AA7EZ;AA+EY;EACE,sDAAA;EACA,6CAAA;AA7Ed;AAgFY;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AA9Ed;AAiFY;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AA/Ed;AAiFc;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;AA/EhB;AAkFc;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;AAhFhB;AAsFQ;EACE,gBAAA;EACA,kBAAA;EACA,8CAAA;EACA,yCAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,4BAAA;AApFV;AAwFM;EACE,kBAAA;EACA,iDAAA;EACA,+CAAA;AAtFR;AAwFQ;EACE,0BAAA;EACA,eAAA;EACA,gBAAA;AAtFV;AA2FI;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,0CAAA;EACA,2CAAA;EACA,8CAAA;AAzFN;AA2FM;EACE,8BAAA;EACA,YAAA;AAzFR;AA4FM;EACE,uBAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;AA1FR;AA6FM;EACE,SAAA;EACA,0BAAA;EACA,eAAA;AA3FR;;AAiGA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;AA9FF;AAgGE;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,uBAAA;AA9FJ;;AAkGA;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;AA/FF;AAiGE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,0CAAA;EACA,2CAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,iFACE;EAGF,yCAAA;AAlGJ;AAoGI;EACE,6CAAA;EACA,sFAAA;AAlGN;AAwGI;EACE,aAAA;EACA,8BAAA;EACA,wDAAA;AAtGN;AA0GE;EACE,SAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAxGJ;AA2GE;EACE,cAAA;EACA,0BAAA;EACA,+BAAA;AAzGJ;AA2GI;EACE,yBAAA;EACA,uBAAA;AAzGN;AA6GE;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,4BAAA;EACA,gBAAA;EACA,UAAA;EACA,0CAAA;EACA,2CAAA;EACA,mBAAA;EACA,0EACE;AA5GN;AAgHE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,iBAAA;EACA,kDAAA;EACA,2DAAA;AA9GJ;AAiHE;EACE,cAAA;EACA,0BAAA;AA/GJ;AAkHE;EACE,SAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,aAAA;AAhHJ;AAkHI;EACE,0BAAA;EACA,gBAAA;AAhHN;AAoHE;EACE,SAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,iCAAA;AAlHJ;AAoHI;EACE,UAAA;AAlHN;AAqHI;EACE,mCAAA;EACA,kBAAA;AAnHN;AAuHE;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,gBAAA;AArHJ;AAwHE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,oBAAA;EACA,iCAAA;AAtHJ;AAwHI;EACE,gBAAA;AAtHN;AAyHI;EACE,8CAAA;AAvHN;AA0HI;EACE,8CAAA;EACA,mDAAA;AAxHN;AA2HI;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;AAzHN;AA2HM;EACE,oBAAA;EACA,kBAAA;AAzHR;AA8HE;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AA5HJ;AA+HE;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA7HJ;;AAkIA;EACE,4BAAA;AA/HF;;AAkIA;EAEE,0CAAA;EACA,8CAAA;AAhIF;AAkIE;EALF;IAMI,oCAAA;IACA,wCAAA;IACA,8BAAA;EA/HF;AACF;;AAkIA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;AA/HF;AAiIE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,2CAAA;EACA,mBAAA;EACA,2DAAA;AA/HJ;AAkIE;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;AAhIJ;AAmIE;EACE,SAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAjIJ;AAoIE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,2CAAA;EACA,mBAAA;EACA,2DAAA;AAlIJ;AAqIE;EACE,cAAA;EACA,0BAAA;AAnIJ;AAsIE;EACE,SAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,aAAA;AApIJ;AAsII;EACE,0BAAA;EACA,gBAAA;AApIN;AAwIE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;EACA,2CAAA;EACA,mBAAA;EACA,0CAAA;EACA,4BAAA;EACA,gBAAA;EACA,iCAAA;AAtIJ;AAyIE;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;AAvIJ;AA0IE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,oBAAA;EACA,iCAAA;EACA,kBAAA;AAxIJ;AA0II;EACE,8CAAA;AAxIN;AA2II;EACE,YAAA;EACA,mBAAA;AAzIN;AA4II;EACE,8CAAA;EACA,mDAAA;AA1IN;AA6II;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,4BAAA;AA3IN;AA8II;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;AA5IN;AAgJE;EACE,WAAA;AA9IJ;AAiJE;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AA/IJ;AAkJE;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAhJJ;AAmJE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,2CAAA;EACA,mBAAA;EACA,2DAAA;AAjJJ;AAoJE;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,yBAAA;EACA,sBAAA;AAlJJ;AAqJE;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;AAnJJ;AAsJE;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,WAAA;AApJJ;AAuJE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;EACA,2BAAA;EACA,iBAAA;EACA,kBAAA;EACA,0CAAA;EACA,mDAAA;AArJJ;AAuJI;;EAEE,WAAA;AArJN;AAyJE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAvJJ;AA0JE;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;AAxJJ;;AA4JA;EACE;IACE,uBAAA;EAzJF;EA2JA;IACE,yBAAA;EAzJF;AACF;AA4JA;EACE;IAEE,UAAA;EA3JF;EA6JA;IACE,YAAA;EA3JF;AACF;AA8JA;EACE;IACE,aAAA;EA5JF;EA8JE;IACE,sBAAA;IACA,SAAA;IACA,oBAAA;IACA,aAAA;EA5JJ;EA8JI;IACE,sBAAA;IACA,uBAAA;IACA,SAAA;EA5JN;EA8JM;IACE,kBAAA;EA5JR;EAgKI;IACE,sBAAA;IACA,WAAA;IACA,SAAA;IACA,kBAAA;EA9JN;EAgKM;IACE,WAAA;IACA,wBAAA;IACA,eAAA;EA9JR;EAgKQ;IACE,SAAA;IACA,eAAA;EA9JV;EAkKM;IACE,kBAAA;IACA,SAAA;IACA,WAAA;IACA,WAAA;IACA,eAAA;IACA,eAAA;EAhKR;EAmKM;IACE,WAAA;IACA,uBAAA;EAjKR;EAsKE;IACE,qCAAA;IACA,SAAA;EApKJ;EAsKI;IACE,aAAA;EApKN;EAsKM;IACE,iBAAA;EApKR;EAyKE;IACE,0BAAA;IACA,SAAA;EAvKJ;AACF","sourcesContent":[".device-monitor {\n  padding: 24px;\n  min-height: 100vh;\n  background: var(--m-background-color);\n\n  .loading-spinner {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 60vh;\n    color: var(--m-text-light);\n\n    .spin {\n      animation: spin 1s linear infinite;\n      margin-bottom: 1rem;\n      color: var(--m-primary);\n    }\n\n    p {\n      color: var(--m-text-muted);\n      font-size: 14px;\n    }\n  }\n\n  .monitor-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 24px;\n    padding: 20px;\n    background: var(--m-card-background-color);\n    border-radius: var(--m-border-radius-md, 12px);\n    border: 1px solid var(--m-border-card-file);\n    box-shadow: var(--m-box-shadow-car, 0 2px 8px rgba(0, 0, 0, 0.04));\n    position: relative;\n\n    .header-left {\n      display: flex;\n      align-items: center;\n      gap: 16px;\n\n      h1 {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        margin: 0;\n        font-size: 1.5rem;\n        font-weight: 600;\n        color: var(--m-text);\n\n        svg {\n          color: var(--m-primary);\n        }\n      }\n\n      .connection-status {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        padding: 6px 14px;\n        background: var(--m-background-subtle-primary);\n        border-radius: 20px;\n        border: 1px solid var(--m-primary-subtle);\n        font-size: 13px;\n        font-weight: 500;\n        color: var(--m-primary);\n\n        .status-indicator {\n          width: 8px;\n          height: 8px;\n          border-radius: 50%;\n\n          &.online {\n            background: var(--m-success);\n            box-shadow: 0 0 8px var(--m-success);\n            animation: pulse 2s infinite;\n          }\n\n          &.offline {\n            background: var(--m-subtle-xbolder);\n          }\n        }\n      }\n    }\n\n    .header-right {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n      flex-wrap: wrap;\n      position: relative;\n\n      .period-selector {\n        display: flex;\n        align-items: center;\n        gap: 4px;\n        background: var(--m-background-subtle-primary);\n        border: 1px solid var(--m-primary-subtle);\n        border-radius: 8px;\n        padding: 4px;\n\n        .day-navigation {\n          display: flex;\n          align-items: center;\n          gap: 4px;\n          margin-right: 4px;\n          padding-right: 8px;\n          border-right: 1px solid var(--m-primary-subtle);\n\n          .nav-day-btn {\n            padding: 6px 10px;\n            background: transparent;\n            color: var(--m-text-light);\n            border: none;\n            border-radius: 6px;\n            cursor: pointer;\n            font-size: 13px;\n            font-weight: 500;\n            transition: all 0.2s ease;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            min-width: 32px;\n            height: 32px;\n\n            &:hover:not(:disabled) {\n              background: var(--m-background-subtle-primary-hovered);\n              color: var(--m-text);\n            }\n\n            &:disabled {\n              opacity: 0.4;\n              cursor: not-allowed;\n            }\n          }\n\n          .selected-date-label {\n            padding: 6px 12px;\n            color: var(--m-text);\n            font-size: 13px;\n            font-weight: 500;\n            min-width: 80px;\n            text-align: center;\n            white-space: nowrap;\n          }\n        }\n\n        .period-btn {\n          padding: 8px 16px;\n          background: transparent;\n          color: var(--m-text-light);\n          border: none;\n          border-radius: 6px;\n          cursor: pointer;\n          font-size: 13px;\n          font-weight: 500;\n          transition: all 0.2s ease;\n          white-space: nowrap;\n          display: flex;\n          align-items: center;\n          gap: 6px;\n\n          &:hover {\n            background: var(--m-background-subtle-primary-hovered);\n            color: var(--m-text);\n          }\n\n          &.active {\n            background: var(--m-primary);\n            color: var(--m-white);\n            box-shadow: 0 2px 4px rgba(12, 132, 121, 0.2);\n          }\n        }\n      }\n\n      .custom-date-badge {\n        display: flex;\n        align-items: center;\n        gap: 6px;\n        padding: 4px 10px;\n        background: var(--m-background-subtle-primary);\n        color: var(--m-text);\n        border: 1px solid var(--m-border-card-file);\n        border-radius: 6px;\n        font-size: 12px;\n        font-weight: 400;\n        white-space: nowrap;\n\n        span {\n          display: flex;\n          align-items: center;\n        }\n\n        .clear-badge-btn {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          background: transparent;\n          border: none;\n          width: 16px;\n          height: 16px;\n          cursor: pointer;\n          padding: 0;\n          color: var(--m-text-light);\n          flex-shrink: 0;\n\n          &:hover {\n            color: var(--m-text);\n          }\n\n          svg {\n            width: 12px;\n            height: 12px;\n          }\n        }\n      }\n\n      .custom-date-range-picker {\n        position: absolute;\n        top: calc(100% + 8px);\n        right: 0;\n        background: var(--m-card-background-color);\n        border: 1px solid var(--m-border-card-file);\n        border-radius: var(--m-border-radius-md, 12px);\n        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n        padding: 20px;\n        z-index: 1000;\n        min-width: 450px;\n        max-width: 550px;\n        margin-top: 8px;\n\n        .date-range-header {\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n          margin-bottom: 16px;\n          padding-bottom: 12px;\n          border-bottom: 1px solid var(--m-border-card-file);\n\n          span {\n            font-size: 14px;\n            font-weight: 600;\n            color: var(--m-text);\n          }\n\n          .close-date-picker {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            width: 28px;\n            height: 28px;\n            padding: 0;\n            background: transparent;\n            border: none;\n            border-radius: 6px;\n            cursor: pointer;\n            color: var(--m-text-light);\n            transition: all 0.2s ease;\n\n            &:hover {\n              background: var(--m-background-subtle-primary);\n              color: var(--m-text);\n            }\n          }\n        }\n\n        .date-range-inputs {\n          display: flex;\n          flex-direction: column;\n          gap: 16px;\n\n          .date-input-group {\n            flex: 1;\n          }\n\n          .date-range-actions {\n            display: flex;\n            gap: 8px;\n            margin-top: 8px;\n\n            .apply-date-range-btn {\n              flex: 1;\n              padding: 10px 20px;\n              background: var(--m-background-primary);\n              color: var(--m-white);\n              border: none;\n              border-radius: 6px;\n              cursor: pointer;\n              font-size: 14px;\n              font-weight: 500;\n              transition: all 0.2s ease;\n\n              &:hover:not(:disabled) {\n                background: var(--m-background-primary-hovered);\n                transform: translateY(-1px);\n                box-shadow: 0 2px 8px rgba(12, 132, 121, 0.3);\n              }\n\n              &:active:not(:disabled) {\n                transform: translateY(0);\n              }\n\n              &:disabled {\n                opacity: 0.5;\n                cursor: not-allowed;\n                background: var(--m-subtle-xbolder);\n              }\n            }\n\n            .clear-date-range-btn {\n              display: flex;\n              align-items: center;\n              justify-content: center;\n              gap: 6px;\n              padding: 10px 16px;\n              background: var(--m-background-subtle-danger);\n              color: var(--m-danger);\n              border: 1px solid var(--m-border-danger);\n              border-radius: 6px;\n              cursor: pointer;\n              font-size: 13px;\n              font-weight: 500;\n              transition: all 0.2s ease;\n\n              &:hover {\n                background: var(--m-danger);\n                color: var(--m-white);\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .refresh-btn {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      padding: 10px 20px;\n      background: var(--m-background-primary);\n      color: var(--m-white);\n      border: none;\n      border-radius: 8px;\n      cursor: pointer;\n      font-size: 14px;\n      font-weight: 500;\n      transition: all 0.2s ease;\n\n      &:hover {\n        background: var(--m-background-primary-hovered);\n        transform: translateY(-1px);\n        box-shadow: 0 4px 12px rgba(12, 132, 121, 0.2);\n      }\n\n      &:active {\n        transform: translateY(0);\n      }\n    }\n  }\n\n  .machine-stats {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n    gap: 16px;\n    margin-bottom: 24px;\n\n    .stat-card {\n      background: var(--m-card-background-color);\n      padding: 20px;\n      border-radius: var(--m-border-radius-md, 12px);\n      border: 1px solid var(--m-border-card-file);\n      box-shadow: var(--m-box-shadow-car, 0 2px 8px rgba(0, 0, 0, 0.04));\n      text-align: center;\n      transition: all 0.2s ease;\n\n      &:hover {\n        transform: translateY(-2px);\n        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n      }\n\n      .stat-label {\n        font-size: 13px;\n        font-weight: 500;\n        color: var(--m-text-light);\n        margin-bottom: 10px;\n        text-transform: uppercase;\n        letter-spacing: 0.5px;\n      }\n\n      .stat-value {\n        font-size: 2rem;\n        font-weight: 700;\n        color: var(--m-text);\n\n        &.online {\n          color: var(--m-success);\n        }\n\n        &.offline {\n          color: var(--m-danger);\n        }\n      }\n    }\n  }\n\n  .machines-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));\n    gap: 20px;\n\n    .machine-card {\n      background: var(--m-card-background-color);\n      border-radius: var(--m-border-radius-md, 12px);\n      border: 1px solid var(--m-border-card-file);\n      box-shadow: var(--m-box-shadow-car, 0 2px 8px rgba(0, 0, 0, 0.04));\n      overflow: visible;\n      transition: all 0.2s ease;\n      position: relative;\n\n      &.machine-card--dropdown-open {\n        z-index: 10100;\n      }\n\n      &::before {\n        content: \"\";\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 4px;\n        height: 100%;\n        background: var(--m-subtle-xbolder);\n      }\n\n      &.online {\n        &::before {\n          background: var(--m-success);\n        }\n      }\n\n      &.offline {\n        opacity: 0.85;\n\n        &::before {\n          background: var(--m-danger);\n        }\n      }\n\n      &:hover {\n        transform: translateY(-3px);\n        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);\n      }\n\n      .card-header {\n        padding: 20px;\n        background: var(--m-background-subtle-primary);\n        border-bottom: 1px solid var(--m-border-card-file);\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n\n        .machine-name {\n          display: flex;\n          align-items: center;\n          gap: 12px;\n\n          svg {\n            color: var(--m-primary);\n            flex-shrink: 0;\n          }\n\n          h3 {\n            margin: 0;\n            font-size: 1.15rem;\n            font-weight: 600;\n            color: var(--m-text);\n          }\n        }\n\n        .header-actions {\n          display: flex;\n          align-items: center;\n          gap: 12px;\n\n          .telemetry-btn {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            width: 36px;\n            height: 36px;\n            padding: 0;\n            background: var(--m-background-subtle-primary);\n            color: var(--m-primary);\n            border: 1px solid var(--m-primary-subtle);\n            border-radius: 8px;\n            cursor: pointer;\n            transition: all 0.2s ease;\n\n            &:hover {\n              background: var(--m-primary);\n              color: var(--m-white);\n              transform: scale(1.05);\n            }\n\n            &:active {\n              transform: scale(0.95);\n            }\n          }\n\n          .view-activity-mini-btn {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            width: 32px;\n            height: 32px;\n            padding: 0;\n            background: var(--m-primary);\n            color: var(--m-white);\n            border: none;\n            border-radius: 8px;\n            cursor: pointer;\n            transition: all 0.2s ease;\n            margin-right: 8px;\n\n            &:hover {\n              background: var(--m-background-primary-hovered);\n              transform: scale(1.05);\n            }\n\n            &:active {\n              transform: scale(0.95);\n            }\n\n            svg {\n              flex-shrink: 0;\n            }\n          }\n\n          .status-badge {\n            display: flex;\n            align-items: center;\n            gap: 6px;\n            padding: 6px 12px;\n            border-radius: 16px;\n            font-size: 12px;\n            font-weight: 600;\n            text-transform: uppercase;\n            letter-spacing: 0.3px;\n\n            &.online {\n              background: var(--m-background-subtle-success);\n              color: var(--m-success);\n              border: 1px solid var(--m-border-success);\n            }\n\n            &.offline {\n              background: var(--m-background-subtle-danger);\n              color: var(--m-danger);\n              border: 1px solid var(--m-border-danger);\n            }\n          }\n        }\n      }\n\n      .card-body {\n        padding: 15px;\n\n        .info-row {\n          display: flex;\n          align-items: center;\n          gap: 8px;\n          margin-bottom: 12px;\n          font-size: 14px;\n\n          svg {\n            color: var(--m-primary);\n            flex-shrink: 0;\n          }\n\n          .label {\n            font-weight: 600;\n            color: var(--m-text);\n          }\n\n          .value {\n            color: var(--m-text-light);\n          }\n        }\n\n        .divider {\n          height: 1px;\n          background: var(--m-border-card-file);\n          margin: 10px 0;\n        }\n\n        .live-data {\n          display: flex;\n          flex-direction: row;\n          justify-content: center;\n          align-items: center;\n          gap: 12px;\n\n          .data-item {\n            display: flex;\n            align-items: center;\n            flex-direction: column;\n            gap: 10px;\n            padding: 8px;\n            background: var(--m-background-subtle-primary);\n            border: 1px solid var(--m-primary-subtle);\n            border-radius: 10px;\n            transition: all 0.2s ease;\n\n            &:hover {\n              background: var(--m-background-subtle-primary-hovered);\n              border-color: var(--m-primary-subtle-hovered);\n            }\n\n            .data-icon {\n              display: flex;\n              align-items: center;\n              justify-content: center;\n              width: 33px;\n              height: 33px;\n              background: var(--m-primary);\n              color: var(--m-white);\n              border-radius: 10px;\n              font-size: 18px;\n              flex-shrink: 0;\n            }\n\n            .data-content {\n              flex: 1;\n              display: flex;\n              flex-direction: column;\n              gap: 7px;\n\n              .data-label {\n                font-size: 12px;\n                font-weight: 500;\n                color: var(--m-text-light);\n                text-transform: uppercase;\n                letter-spacing: 0.3px;\n                text-align: center;\n              }\n\n              .data-value {\n                font-size: 2rem;\n                font-weight: 600;\n                color: var(--m-text);\n                text-align: center;\n              }\n            }\n          }\n        }\n\n        .last-seen {\n          margin-top: 16px;\n          padding: 10px 14px;\n          background: var(--m-background-subtle-warning);\n          border: 1px solid var(--m-border-warning);\n          border-radius: 8px;\n          text-align: center;\n          font-size: 12px;\n          font-weight: 500;\n          color: var(--m-text-warning);\n        }\n      }\n\n      .card-footer {\n        padding: 14px 20px;\n        background: var(--m-subtle-card-background-color);\n        border-top: 1px solid var(--m-border-card-file);\n\n        small {\n          color: var(--m-text-muted);\n          font-size: 13px;\n          line-height: 1.5;\n        }\n      }\n    }\n\n    .no-machines {\n      grid-column: 1 / -1;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      padding: 4rem 2rem;\n      background: var(--m-card-background-color);\n      border: 1px solid var(--m-border-card-file);\n      border-radius: var(--m-border-radius-md, 12px);\n\n      svg {\n        color: var(--m-subtle-xbolder);\n        opacity: 0.5;\n      }\n\n      h3 {\n        margin: 1.5rem 0 0.5rem;\n        color: var(--m-text);\n        font-weight: 600;\n        font-size: 1.25rem;\n      }\n\n      p {\n        margin: 0;\n        color: var(--m-text-light);\n        font-size: 14px;\n      }\n    }\n  }\n}\n\n.device-monitor-inventory-edit {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 4px;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n\n  &__actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    justify-content: center;\n  }\n}\n\n.device-monitor-inventory-dropdown {\n  position: relative;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  z-index: 10050;\n\n  &__trigger {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    width: 100%;\n    min-height: 42px;\n    padding: 10px 12px;\n    background: var(--m-card-background-color);\n    border: 1px solid var(--m-border-card-file);\n    border-radius: 10px;\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--m-text);\n    cursor: pointer;\n    text-align: left;\n    transition:\n      border-color 0.15s ease,\n      box-shadow 0.15s ease,\n      background 0.15s ease;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n\n    &:hover {\n      border-color: var(--m-primary-subtle-hovered);\n      background: var(\n        --m-background-subtle-primary-hovered,\n        var(--m-card-background-color)\n      );\n    }\n\n    &:focus-visible {\n      outline: none;\n      border-color: var(--m-primary);\n      box-shadow: 0 0 0 3px var(--m-background-subtle-primary);\n    }\n  }\n\n  &__value {\n    flex: 1;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    line-height: 1.3;\n  }\n\n  &__chevron {\n    flex-shrink: 0;\n    color: var(--m-text-light);\n    transition: transform 0.2s ease;\n\n    &.is-open {\n      transform: rotate(180deg);\n      color: var(--m-primary);\n    }\n  }\n\n  &__menu {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: calc(100% + 6px);\n    z-index: 10051;\n    display: flex;\n    flex-direction: column;\n    max-height: min(220px, 44vh);\n    overflow: hidden;\n    padding: 0;\n    background: var(--m-card-background-color);\n    border: 1px solid var(--m-border-card-file);\n    border-radius: 10px;\n    box-shadow:\n      0 4px 6px rgba(0, 0, 0, 0.06),\n      0 12px 28px rgba(0, 0, 0, 0.12);\n  }\n\n  &__search {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-shrink: 0;\n    padding: 8px 10px;\n    border-bottom: 1px solid var(--m-border-card-file);\n    background: var(--m-background-subtle-primary, transparent);\n  }\n\n  &__search-icon {\n    flex-shrink: 0;\n    color: var(--m-text-light);\n  }\n\n  &__search-input {\n    flex: 1;\n    min-width: 0;\n    border: none;\n    background: transparent;\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--m-text);\n    outline: none;\n\n    &::placeholder {\n      color: var(--m-text-light);\n      font-weight: 400;\n    }\n  }\n\n  &__menu-scroll {\n    flex: 1;\n    min-height: 0;\n    overflow-x: hidden;\n    overflow-y: auto;\n    padding: 6px;\n    -webkit-overflow-scrolling: touch;\n\n    &::-webkit-scrollbar {\n      width: 6px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: var(--m-primary-subtle);\n      border-radius: 6px;\n    }\n  }\n\n  &__empty {\n    padding: 14px 12px;\n    text-align: center;\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--m-text-light);\n    line-height: 1.4;\n  }\n\n  &__option {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 3px;\n    width: 100%;\n    padding: 10px 12px;\n    margin-bottom: 2px;\n    border: none;\n    border-radius: 8px;\n    background: transparent;\n    cursor: pointer;\n    text-align: left;\n    font: inherit;\n    color: var(--m-text);\n    transition: background 0.12s ease;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    &:hover {\n      background: var(--m-background-subtle-primary);\n    }\n\n    &.is-selected {\n      background: var(--m-background-subtle-primary);\n      box-shadow: inset 0 0 0 1px var(--m-primary-subtle);\n    }\n\n    &--placeholder {\n      font-size: 13px;\n      font-weight: 500;\n      color: var(--m-text-light);\n      font-style: italic;\n\n      &.is-selected {\n        color: var(--m-text);\n        font-style: normal;\n      }\n    }\n  }\n\n  &__option-code {\n    width: 100%;\n    font-size: 13px;\n    font-weight: 700;\n    color: var(--m-primary);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    line-height: 1.25;\n  }\n\n  &__option-name {\n    width: 100%;\n    font-size: 12px;\n    font-weight: 500;\n    color: var(--m-text-light);\n    line-height: 1.35;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n// Product type edit modal: allow dropdown to overflow above modal body scroll\n.device-monitor-product-type-modal__body {\n  overflow: visible !important;\n}\n\n.device-monitor-product-type-modal {\n  // This class is applied on the modal content container (BaseUI/Modal passes it through).\n  width: min(720px, calc(100vw - 24px)) !important;\n  max-width: min(720px, calc(100vw - 24px)) !important;\n\n  @media (max-width: 640px) {\n    width: calc(100vw - 16px) !important;\n    max-width: calc(100vw - 16px) !important;\n    border-radius: 12px !important;\n  }\n}\n\n.device-monitor-product-type-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n\n  &__summary {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 10px 12px;\n    border: 1px solid var(--m-border-card-file);\n    border-radius: 10px;\n    background: var(--m-background-subtle-primary, transparent);\n  }\n\n  &__summary-label {\n    font-size: 12px;\n    font-weight: 700;\n    color: var(--m-text-light);\n    text-transform: uppercase;\n    letter-spacing: 0.02em;\n    white-space: nowrap;\n  }\n\n  &__summary-value {\n    flex: 1;\n    min-width: 0;\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--m-text);\n    text-align: right;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__search {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 12px;\n    border: 1px solid var(--m-border-card-file);\n    border-radius: 10px;\n    background: var(--m-background-subtle-primary, transparent);\n  }\n\n  &__search-icon {\n    flex-shrink: 0;\n    color: var(--m-text-light);\n  }\n\n  &__search-input {\n    flex: 1;\n    min-width: 0;\n    border: none;\n    background: transparent;\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--m-text);\n    outline: none;\n\n    &::placeholder {\n      color: var(--m-text-light);\n      font-weight: 400;\n    }\n  }\n\n  &__items {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    padding: 6px;\n    border: 1px solid var(--m-border-card-file);\n    border-radius: 10px;\n    background: var(--m-card-background-color);\n    max-height: min(320px, 55vh);\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  &__empty {\n    padding: 14px 12px;\n    text-align: center;\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--m-text-light);\n  }\n\n  &__item {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 3px;\n    width: 100%;\n    padding: 10px 12px;\n    border: none;\n    border-radius: 8px;\n    background: transparent;\n    cursor: pointer;\n    text-align: left;\n    font: inherit;\n    color: var(--m-text);\n    transition: background 0.12s ease;\n    position: relative;\n\n    &:hover:not(:disabled) {\n      background: var(--m-background-subtle-primary);\n    }\n\n    &:disabled {\n      opacity: 0.6;\n      cursor: not-allowed;\n    }\n\n    &.is-selected {\n      background: var(--m-background-subtle-primary);\n      box-shadow: inset 0 0 0 1px var(--m-primary-subtle);\n    }\n\n    &.is-selected::before {\n      content: \"\";\n      position: absolute;\n      left: 0;\n      top: 8px;\n      bottom: 8px;\n      width: 3px;\n      border-radius: 3px;\n      background: var(--m-primary);\n    }\n\n    &--placeholder {\n      font-size: 13px;\n      font-weight: 500;\n      color: var(--m-text-light);\n      font-style: italic;\n    }\n  }\n\n  &__placeholder {\n    width: 100%;\n  }\n\n  &__code {\n    width: 100%;\n    font-size: 13px;\n    font-weight: 700;\n    color: var(--m-primary);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    line-height: 1.25;\n  }\n\n  &__name {\n    width: 100%;\n    font-size: 12px;\n    font-weight: 500;\n    color: var(--m-text-light);\n    line-height: 1.35;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__selected {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    gap: 8px 12px;\n    padding: 10px 12px;\n    border: 1px solid var(--m-border-card-file);\n    border-radius: 10px;\n    background: var(--m-background-subtle-primary, transparent);\n  }\n\n  &__selected-label {\n    width: 100%;\n    font-size: 12px;\n    font-weight: 700;\n    color: var(--m-text-light);\n    text-transform: uppercase;\n    letter-spacing: 0.02em;\n  }\n\n  &__selected-empty {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--m-text-light);\n    font-style: italic;\n  }\n\n  &__selected-chips {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    width: 100%;\n  }\n\n  &__selected-chip {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    min-width: 0;\n    max-width: min(240px, 100%);\n    padding: 8px 10px;\n    border-radius: 8px;\n    background: var(--m-card-background-color);\n    box-shadow: inset 0 0 0 1px var(--m-primary-subtle);\n\n    .device-monitor-product-type-list__code,\n    .device-monitor-product-type-list__name {\n      width: auto;\n    }\n  }\n\n  &__pagination {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n  }\n\n  &__page-info {\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--m-text);\n    white-space: nowrap;\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n@media (max-width: 768px) {\n  .device-monitor {\n    padding: 16px;\n\n    .monitor-header {\n      flex-direction: column;\n      gap: 16px;\n      align-items: stretch;\n      padding: 16px;\n\n      .header-left {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 12px;\n\n        h1 {\n          font-size: 1.25rem;\n        }\n      }\n\n      .header-right {\n        flex-direction: column;\n        width: 100%;\n        gap: 12px;\n        position: relative;\n\n        .period-selector {\n          width: 100%;\n          justify-content: stretch;\n          flex-wrap: wrap;\n\n          .period-btn {\n            flex: 1;\n            min-width: 80px;\n          }\n        }\n\n        .custom-date-range-picker {\n          position: relative;\n          top: auto;\n          right: auto;\n          width: 100%;\n          min-width: auto;\n          max-width: none;\n        }\n\n        .refresh-btn {\n          width: 100%;\n          justify-content: center;\n        }\n      }\n    }\n\n    .machine-stats {\n      grid-template-columns: repeat(2, 1fr);\n      gap: 12px;\n\n      .stat-card {\n        padding: 16px;\n\n        .stat-value {\n          font-size: 1.5rem;\n        }\n      }\n    }\n\n    .machines-grid {\n      grid-template-columns: 1fr;\n      gap: 16px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
